import { render } from "./CustomLabel.vue?vue&type=template&id=5667a6a9&ts=true"
import script from "./CustomLabel.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomLabel.vue?vue&type=script&lang=ts&setup=true"

import "./CustomLabel.vue?vue&type=style&index=0&id=5667a6a9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/CustomLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5667a6a9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5667a6a9', __exports__)) {
    api.reload('5667a6a9', __exports__)
  }
  
  module.hot.accept("./CustomLabel.vue?vue&type=template&id=5667a6a9&ts=true", () => {
    api.rerender('5667a6a9', render)
  })

}


export default __exports__